module.exports = __webpack_public_path__ + "static/media/CalendarCheckInactive.97abad86.svg";